var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /builds/johannes-jonsson/consmin-app/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0